<template>
  <v-card>
    <v-toolbar dense color="red lighten-1">
      <v-toolbar-title class="white--text">Imposto de Renda Inseridos</v-toolbar-title>
    </v-toolbar>
    <v-card-actions>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Pesquisar"
        single-line
        hide-details
        class="mx-2"
      ></v-text-field>
    </v-card-actions>
    <v-card-text>
      <v-data-table :items="income_taxes" :headers="headers" :search="search">
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn icon @click="downloadPDF(item.id)">
            <v-icon color="green">mdi-cloud-download</v-icon>
          </v-btn>
          <v-btn icon @click="deletePDF(item.id)">
            <v-icon color="red">mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ITList',
  data: () => {
    return {
      search: '',
      headers: [
        { text: 'Nome do Funcionário', align: 'start', value: 'full_name' },
        { text: 'Ano', value: 'year' },
        { text: 'Ação', value: 'actions' },
      ],
    }
  },
  computed: {
    ...mapState('employees', ['income_taxes']),
  },
  methods: {
    ...mapActions('employees', ['ActionDownloadIncomeTaxPDF', 'ActionDeleteIncomeTax']),
    ...mapActions('ui', ['ActionSetLoading']),
    async downloadPDF(id) {
      try {
        this.ActionDownloadIncomeTaxPDF(id)
      } catch (error) {}
    },
    async deletePDF(id) {
      this.ActionSetLoading(true)
      try {
        await this.$swal({
          icon: 'warning',
          title: 'Atenção',
          text: 'Deseja deletar esse imposto de renda?',
          showCancelButton: true,
        }).then((result) => {
          if (result.isConfirmed) {
            this.ActionDeleteIncomeTax(id)
            this.$swal({
              icon: 'success',
              title: 'Deletado',
              text: 'Imposto de Renda deletado com sucesso',
            })
          }
        })
      } catch (error) {}
      this.ActionSetLoading(false)
    },
  },
}
</script>
